<template>
    <div>
        <header-message class="text-error mt-5 mb-5">Calibration has FAILED</header-message>

        <header-message class="mt-5 mb-5">Vehicle is NOT ready for a test drive</header-message>

        <div class="buttonrow">
            <button-button class="btn btn-primary" type="submit" @click.prevent="acknowledgeClicked">Acknowledge</button-button>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageBase from "@/shared/components/common/PageBase";
import HeaderMessage from "@/components/HeaderMessage.vue";
import { Global } from "@/support/GlobalData";
import { CalibrationEventSupport } from "@/support/CalibrationEvent";
import { DeviceStatusDto } from "@/shared/models/DeviceStatusDto";
import { SignalR } from "@/support/SignalR";

export default defineComponent({
    name: "CalibrationFailed",
    components: {
        HeaderMessage,
    },
    mixins: [PageBase],
    mounted(): void {
        SignalR.onGetCurrentStatusForListeners = this.getCurrentStatusForListeners;
        SignalR.onAcknowledgeByCompanion = this.acknowledgeClicked;
        SignalR.onCalibrationFailed = (): void => {
            // no action (ignore)
        };
        this.getCurrentStatusForListeners();
    },
    unmounted(): void {
        SignalR.onGetCurrentStatusForListeners = null;
        SignalR.onAcknowledgeByCompanion = null;
        SignalR.onCalibrationFailed = null;
    },
    methods: {
        acknowledgeClicked(): void {
            CalibrationEventSupport.sendEventStatus({
                Page: "CalibrationEnded",
            } as DeviceStatusDto);

            Global.MainApp.clearSession();
            this.$router.push("/");
        },
        getCurrentStatusForListeners(): void {
            CalibrationEventSupport.sendEventStatus({
                Page: "CalibrationFailed",
            } as DeviceStatusDto);
        },
    },
});
</script>
